import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { FormattedMessage } from 'react-intl';
import { NotificationBanner } from '../elements-banner/notification-banner';
import { Footer } from '../shared-components/footer/footer';
import SharedIntlProviderHOC from '../shared-components/hocs/sharedIntlProviderHOC';
import { CateringFaqSection } from './catering-faqs/CateringFAQSection';
import { CateringHeroSection } from './catering-hero/CateringHeroSection';
import { CateringPackageSections } from './catering-packages/CateringPackageSections';
import { CateringTestimonialsSection } from './catering-testimonials/CateringTestimonialsSection';
import { CateringContactBanner } from './catering-banners/CateringContactBanner';
import { CateringExperienceBanner } from './catering-banners/CateringExperienceBanner';
import FAQs from './catering-faqs/catering-faqs.json';

export const CateringPage = ({ booking, listing }) => {
  useEffect(() => {
    const isInstantBooking = booking?.is_instant_booking;
    const objState = booking?.obj_state;
    const shouldRender =
      (isInstantBooking && 'ACTIVE' === objState) ||
      (!isInstantBooking && 'REQUESTED' === objState);
    if (shouldRender) {
      const message =
        'ACTIVE' === objState ? (
          <FormattedMessage
            id="catering_page.request_confirmed"
            defaultMessage="Your booking is confirmed."
          />
        ) : 'REQUESTED' === objState ? (
          <FormattedMessage
            id="catering_page.request_sent"
            defaultMessage="Booking request sent!"
          />
        ) : (
          ''
        );
      if (message) {
        ReactDOM.render(
          <SharedIntlProviderHOC>
            <NotificationBanner showClose timing={4.6} message={message} />
          </SharedIntlProviderHOC>,
          document.getElementById('banner-container')
        );
      }
    }
  }, [booking]);

  return (
    <div className="CateringPage relative">
      <CateringHeroSection booking={booking} listing={listing} />

      <CateringPackageSections booking={booking} />

      <CateringExperienceBanner />

      <CateringTestimonialsSection />

      <CateringFaqSection FAQs={FAQs} />

      <CateringContactBanner />

      <Footer />
    </div>
  );
};
